import { Animation, createAnimation } from '@ionic/angular/standalone';

// Los del README para las hojas. Son valores de Web Animations: no pueden leer un token de CSS.
const DURATION_MS = 380;
const EASING = 'cubic-bezier(0.22, 1, 0.36, 1)';

function sheetAnimation(base: HTMLElement, from: string, to: string, backdropFrom: string, backdropTo: string): Animation {
  const root = base.shadowRoot ?? base;
  return createAnimation()
    .addElement(base)
    .easing(EASING)
    .duration(DURATION_MS)
    .addAnimation([
      createAnimation()
        .addElement(root.querySelector('ion-backdrop') as Element)
        .fromTo('opacity', backdropFrom, backdropTo),
      createAnimation()
        .addElement(root.querySelector('.modal-wrapper') as Element)
        .fromTo('transform', from, to)
        .fromTo('opacity', '1', '1'),
    ]);
}

export const modalSheetEnter = (base: HTMLElement): Animation =>
  sheetAnimation(base, 'translateY(100%)', 'translateY(0)', '0', 'var(--backdrop-opacity)');

export const modalSheetLeave = (base: HTMLElement): Animation =>
  sheetAnimation(base, 'translateY(0)', 'translateY(100%)', 'var(--backdrop-opacity)', '0');
